import * as React from "react";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import "./routes.css";

// Each testimonial: {who, quote}. Quote may be a string or JSX.
const bodywork = [
  {
    who: "DD, 60s",
    quote: (
      <>
        <p>
          Hi Ann, I&rsquo;m off tomorrow, but before leaving want you to know
          that I have happily reduced my Tylenol to 4x 650/day. If it
          wasn&rsquo;t for the 15 hr plane ride I&rsquo;d be reducing it some
          more. Your last session was, I believe, a breakthrough and I look
          forward to setting up a series of appointments in March. I am
          thrilled to be feeling so much better on the eve of this exciting
          trip. Thank you.
        </p>
        <p>
          I thought you&rsquo;d like to know that Friday&rsquo;s appointment
          was a real breakthrough. My neck is STILL feeling much better!!! I
          have never been able to hold on to the benefits of anyone&rsquo;s
          work for this long. I have also slept significantly better the last
          three nights. Hurrah and MANY THANKS.
        </p>
        <p className="quoteNote">
          DD is now taking only 3 Tylenol a day, occasionally only two, and
          anticipates eventually not needing regular painkillers at all.
        </p>
      </>
    ),
  },
  {
    who: "DC, 40s",
    quote:
      "I really didn't understand what Ann was doing the first few times I went to her. I never had massage like this before, I had the run of the mill massage and although that was nice, it didn't address my pain in any lasting way. Ann explained what she was doing as she worked and I began to understand it and I began to have relief of my decades of chronic pain. I now have no more pain in my lower back and leg. None. I still visit her now and then because Ann is always studying and coming up with new solutions and I like to take advantage of her knowledge so I can feel great.",
  },
  {
    who: "MJ, 50s",
    quote:
      "Hi Ann, thank you so much for your good work yesterday. I have experienced relief and we have found the nexus of the 30 year old issues. I am grateful and look forward to more therapy.",
  },
  {
    who: "CB, 50s",
    quote:
      "New Harmony massage offers a wide range of therapies to meet individual needs. I am healthier and stronger (plus I feel exceptionally better) because of my time here. I recommend New Harmony Massage Therapy to everyone.",
  },
  {
    who: "LJ, 60s",
    quote:
      "Ann is always generous with her time and amazing at sensing what needs repair and reworking. I can't say enough about her care and can highly recommend her.",
  },
  {
    who: "JF, 40s",
    quote:
      "I have had chronic posture issues and when Ann works on me I always come out breathing easier and standing straighter.",
  },
  {
    who: "AW, 40s, to Randy Shepherd",
    quote:
      "Dear Randy, I wanted to thank you for all of the love and attention you have given my body in this past year. What you do is amazing and being able to come to you for a session has been such an important and stabilizing force in my life. I wish that only the best comes to you in the future. I will be sure to look you up any time I'm in the area.",
  },
  {
    who: "SS, 40s",
    quote: "Ann, thanks again. I feel great, still.",
  },
  {
    who: "JB, 40s",
    quote: "Thank you, thank you, thank you.",
  },
];

const movement = [
  {
    who: "Mary G, 40s",
    quote: (
      <>
        <p>
          I keep coming up with little phrases to describe my Movement for
          Body Mind Spirit™ experience:
        </p>
        <ul>
          <li>
            I feel like I&rsquo;ve stretched my heart and soul as well as my
            body. And I&rsquo;ve connected my heart and soul to my body.
          </li>
          <li>
            After class, I feel more creative, energetic, and in tune with the
            natural world.
          </li>
          <li>
            It gives me a different way of moving through my feelings and
            emotions.
          </li>
          <li>
            It connects me with rhythms in my own body, and with the rhythms of
            the rest of the group. It feels like we&rsquo;ve developed a
            community without speaking words.
          </li>
          <li>It gives me a place to explore and experiment.</li>
        </ul>
        <p>
          Here&rsquo;s a great quote about dance as a spiritual practice from a
          book I&rsquo;ve been reading: &ldquo;The ongoing effort to dance, to
          give gesture to what we feel and experience, is ultimately healing
          because, as riverbeds are continually shaped by water that moves
          through them, living beings are continually shaped by the feelings
          and experiences that move through them. If there is no water moving
          through, the riverbed dries up and crumbles. Likewise, if there is no
          feeling moving through the body, the being at the center of that body
          will crumble. In truth, much of our inner sickness comes from the
          buildup and pressure of all that is kept in. The ongoing act of
          releasing that inner buildup is what spiritual practices call
          embodiment. Embodiment is allowing our heart, mind, and body to exist
          as one miraculous skin.&rdquo;
        </p>
        <p className="quoteNote">
          The Book of Awakening, page 207, by Mark Nepo
        </p>
      </>
    ),
  },
  {
    who: "Lana Baumgartner, 25",
    quote:
      "Great! I loved experiencing how unique your teaching style is. Your facilitating inspired me to create new ways of speaking, thinking, moving, a new way to express! I found a whole new dimension through you! I felt an expansion of my own creativity by opening my eyes to the vision you inspired. Love and Dance!",
  },
  {
    who: "Shirley, 70s",
    quote:
      "Ann always finds a way to make every class invigorating and a whole lot of fun in the process. I've been coming since the beginning classes and no class is ever quite the same, but I always come away feeling more limber and in good spirits.",
  },
  {
    who: "Susan, 40s",
    quote:
      "Movement for Body Mind Spirit™ is fun, freedom of movement and self-expression that reminds me we were all children once. It also reminds me we have a connection to the earth, and others around us. See you soon!",
  },
];

function Quote({ who, quote }) {
  return (
    <figure className="quoteCard">
      <blockquote>
        {typeof quote === "string" ? <p>{quote}</p> : quote}
      </blockquote>
      <figcaption>{who}</figcaption>
    </figure>
  );
}

function Testimonials() {
  return (
    <div className="pageBg">
      <div className="container">
        <div className="pageCard">
          <h2 className="pageTitle">Testimonials</h2>

          <p className="pageLead">
            In our clients&rsquo; own words. Names are withheld to protect
            privacy unless requested otherwise.
          </p>

          <h3 className="sectionTitle">Bodywork</h3>
          <div className="quoteGrid">
            {bodywork.map((t) => (
              <Quote key={t.who} {...t} />
            ))}
          </div>

          <h3 className="sectionTitle">Movement for Body Mind Spirit™</h3>
          <div className="quoteGrid">
            {movement.map((t) => (
              <Quote key={t.who} {...t} />
            ))}
          </div>

          <div className="contactBox">
            <h4 className="subTitle" style={{ marginTop: 0 }}>
              We&rsquo;d love to hear from you
            </h4>
            <p>
              Send us your comments, suggestions, testimonials and thoughts,
              and let us know if you are interested in hearing about upcoming
              classes or offerings.
            </p>
            <div className="btnRow">
              <a href="mailto:bodymindspiritanatomy@gmail.com">
                <Button>Email Your Testimonial ››</Button>
              </a>
              <Link to="/classes">
                <Button variant="outline-primary">Class Information ››</Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Testimonials;
